module.exports = __webpack_public_path__ + "img/logo-icon-app.c092b5d4.png";